import { doDefaultFetch } from '@nhl/fetch-helpers';

const publicUrl = (args) => args.isPublic ? '/public' : '';
const storyBucketEndpoint = (args) => `/site/api/stories${publicUrl(args)}`
    + `?cayenneExp=seasonId=${args.seasonId} and storySlug="${args.name}"`
    + `&include=details`;
const storyDetailEndpoint = (args) => `/site/api/stories${publicUrl(args)}/${args.id}/details/${args.detailId}`;


const fetchStories = (args) => doDefaultFetch(storyBucketEndpoint(args), args);
const fetchStoryDetails = (args) => doDefaultFetch(storyDetailEndpoint(args), args);

export default {
    fetchStories,
    fetchStoryDetails,
};